module.exports = __webpack_public_path__ + "img/upload-file-icon-area.a71a669e.svg";